import { render, staticRenderFns } from "./SchoolFees.vue?vue&type=template&id=1f995cb3&scoped=true"
import script from "./SchoolFees.vue?vue&type=script&lang=js"
export * from "./SchoolFees.vue?vue&type=script&lang=js"
import style0 from "./SchoolFees.vue?vue&type=style&index=0&id=1f995cb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f995cb3",
  null
  
)

export default component.exports